import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Menu from "./Menu";
import './index.scss';
import { inject, observer } from "mobx-react";
import UserTop from "../user";
import IsAuth from "./IsAuth";

import cover from '../table/cover';
import BpSave from '../setting/BpSave';
import compared from '../compared';
import comparedDetail from '../compared/Detail';
import Headquarters from '../setting/Headquarters';
import personal from '../user/personal';
import meetingFlash from '../table/meetingFlash';
// import WeekMeeting from '../table/meetingFlash/Week';
import LabelManagement from '../setting/LabelManagement';
import guestRating from '../table/guestRating';
import groupOfChannels from '../table/guestRating/channels';
import criticism from '../table/guestRating/channels/criticism';
import monthlyAnalysis from '../table/monthlyAnalysis';
import financePersonnel from '../table/finance/personnel';
import kpifollow from '../otherHeadquartersForms/kpifollow';
import salesPersonnel from '../otherHeadquartersForms/salesPersonnelAssessment';

// 合同管理
import contract from '../contract';

// 月度会议记录
import meetingMinutes from '../table/other/meetingMinutes';

// 表格1-?、
// import table1_1 from '../table/1-KPI/1-1KeyPerformanceIndicator';
// import table1_2 from '../table/1-KPI/1-2FlowThruAnalysis';
// import table1_3 from '../table/1-KPI/1-3';
import table1 from '../table/1-KPI';

// 表格2-?、
import table2_1 from '../table/2-Analysis/2-1';
import table2_2 from '../table/2-Analysis/2-2';
import table2_3 from '../table/2-Analysis/2-3';
// import table2_4 from '../table/2-Analysis/2-4';
// import table2_5 from '../table/2-Analysis/2-5';
// import table2_6 from '../table/2-Analysis/2-6';
import table2_7 from '../table/2-Analysis/2-7';
import table2_8 from '../table/2-Analysis/2-8';
// import table2_9 from '../table/2-Analysis/2-9';

// 表格3-?、
import table3_1 from '../table/3.0/3-1';
import table3_2 from '../table/3.0/3-2';
import table3_3 from '../table/3.0/3-3';

// 表格4-?、
import table4_1 from '../table/4.0/4-1';
import table4_2 from '../table/4.0/4-2-daily';
import table4_2_2 from '../table/4.0/4-2/4.2.2';
import table4_2_3 from '../table/4.0/4-2/4.2.3';
import table4_2_4 from '../table/4.0/4-2/4.2.4';
import table4_2_5 from '../table/4.0/4-2/4.2.5';
import table4_2_6 from '../table/4.0/4-2/4.2.6';
import table4_2_7 from '../table/4.0/4-2/4.2.7';
import table4_2_summary from '../table/4.0/4-2-daily/summary';
import fullRoom from '../table/4.0/4-2-daily/fullRoom';
import table4_2_holidaySummary from '../table/4.0/4-2-daily/holidaySummary';
import table4_3 from '../table/4.0/4-3';
import table4_4 from '../table/4.0/4-4';
import table4_5 from '../table/4.0/4-5';
// 区域报表 图表
import chineseNewYear_4_2 from '../table/4.0/4-2-daily/regionalReport/chineseNewYear';
import mayDay_4_2 from '../table/4.0/4-2-daily/regionalReport/mayDay';
import eleven_4_2 from '../table/4.0/4-2-daily/regionalReport/eleven';
import year_4_2 from '../table/4.0/4-2-daily/regionalReport/year';

// 4.0新表
import news4_3_1 from '../table/4new/4.3/4.3.1';
import news4_3_2 from '../table/4new/4.3/4.3.2';
import news4_2_1 from '../table/4new/4.2/4.2.1';
import news4_2_2 from '../table/4new/4.2/4.2.2';

// 表格5-?、
import table5 from '../table/5.0/5';
import table5_1 from '../table/5.0/5-1';
import table5_2 from '../table/5.0/5-2';
import table5_3 from '../table/5.0/5-3';
import table5_5 from '../table/5.0/5-5';
import table5_6 from '../table/5.0/5-6';
import table5_8 from '../table/5.0/5-8';
import table5_9 from '../table/5.0/5-9';
import table5_10 from '../table/5.0/5-10';

// 表格6-?、
import table6_1 from '../table/6.0/6-1';
import table6_2 from '../table/6.0/6-2';
import table6_3 from '../table/6.0/6-3new';
// import table6_4 from '../table/6.0/6-4';
// import table6_5 from '../table/6.0/6-5';

// 表格7-?、
import table7_1 from '../table/7-HumanResourcesAnalysis/7-1TotalPayrollCostAnalysis';
import table7_1_1 from '../table/7-HumanResourcesAnalysis/7-1TotalPayrollCostAnalysis/7-1-1PayrollCostByLevel';
import table7_1_2 from '../table/7-HumanResourcesAnalysis/7-1TotalPayrollCostAnalysis/7-1-2Payroll-Cost-By-Department';
import table7_2 from '../table/7-HumanResourcesAnalysis/7-2';
import table7_3 from '../table/7-HumanResourcesAnalysis/7-3/7-3.js';
import table7_4 from '../table/7-HumanResourcesAnalysis/7-4';
import table7_5 from '../table/7-HumanResourcesAnalysis/7-5';
import table7_6 from '../table/7-HumanResourcesAnalysis/7-6';
import table7_7 from '../table/7-HumanResourcesAnalysis/7-7';
// HR迁移过来的7.7 
import table7_8 from '../../hr/table/9.0';
// 表格8-?、
import table8_1 from '../table/8.0/8-1';

// 表格9-?、
import table9_1 from '../table/9.0/9-1';
import table9_2 from '../table/9.0/9-2';
import table9_3 from '../table/9.0/9-3';
import table9_4 from '../table/9.0/9-4';
import table9_5 from '../table/9.0/9-5';
import table9_6 from '../table/9.0/9-6';
import table9_7 from '../table/9.0/9-7';
import table9_8 from '../table/9.0/9-8';
import table9_9 from '../table/9.0/9-9';
import table9_10 from '../table/9.0/9-10';

// 表格10-11、
import table10 from '../table/10';

import table12 from '../table/12';

// 设置、用户
import Hotel from '../setting/hotel';
import User from '../setting/user';
import Setting from '../setting';
import daily from '../table/daily';
import pdf from '../table/pdf';
import comments from '../../bp-views/comments';
import BI_Home from "../BI/home";
import General from "../BI/General";
import BI_Headquarters from "../BI/headquarters";
import Profit from "../BI/profit";

// 特许酒店
import charterFirst from "../charter/first";
import charterSecond from "../charter/second";
import charterThird from "../charter/third";
import charterFourth from "../charter/fourth";
import charterSummary from "../charter/summary";

// 总部表格
import HeadquartersMonth from '../otherHeadquartersForms/4_2Month';
import HeadquartersYear from '../otherHeadquartersForms/4_2Year';
import roomsKPIAnalysisSummary from '../otherHeadquartersForms/roomsKPIAnalysisSummary';
import guestReviewImport from '../otherHeadquartersForms/guestReviewImport';
import performanceReview from "../table/performanceReview";
import performanceAnalysis from "../table/performanceAnalysis";
import performanceDescription from "../table/performanceAnalysis/description";
import analysisChart from "../table/performanceAnalysis/analysisChart";
import groupanalysisChart from "../table/performanceAnalysis/groupanalysisChart";
import ota_fillIn from "../otherHeadquartersForms/OTAChannel/fillIn";
import ota_show from "../otherHeadquartersForms/OTAChannel/show";
import OTA1_2 from "../otherHeadquartersForms/OTAChannel/1.2";
import OTA1_3 from "../otherHeadquartersForms/OTAChannel/1.3";
import OTA1_5 from "../otherHeadquartersForms/OTAChannel/1.5";
import OTA1_4 from "../otherHeadquartersForms/OTAChannel/1.4";
import dailyMonth from "../otherHeadquartersForms/daily/1.1";
import dailyChart from "../otherHeadquartersForms/daily/1.2";
import dailyMonthAllHotels from "../otherHeadquartersForms/daily/1.3";
import dailyMonthAllHotels1_4 from "../otherHeadquartersForms/daily/1.4";
import dailyMonthAllHotels1_5 from "../otherHeadquartersForms/daily/1.5";
import BPBudgetSummary from "../otherHeadquartersForms/BPBudgetSummary";
import BPBudgetSummary8_2_1 from "../otherHeadquartersForms/BPBudgetSummary/BP8_2_1";

// 坪效
import efficiency from "../table/effect";
import effictdescription from "../table/effect/description";
import effect1_2 from "../table/effect/1.2";

// 官网比价
import price1_1 from "../otherHeadquartersForms/price/1.1";
import price1_2 from "../otherHeadquartersForms/price/1.2";
import price1_3 from "../otherHeadquartersForms/price/1.3";
import consulting from "../otherHeadquartersForms/consulting";

// 临时新增五一表格
import mayDay from '../table/mayDay';
import nationalDay from '../table/nationalDay';

// 宴会设施统计
import banquetFacilities from '../table/other/banquetFacilities';
import systemStatistical from '../table/other/systemStatistical';
import DooBi from '../table/other/DooBi';
import urgent from '../table/other/urgent';


import monthlyReview from '../otherHeadquartersForms/monthlyReview';

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
        }
    }

    async componentWillMount() {
        if (!this.props.store.tableSwitch.data.id) {
            this.props.store.tableSwitch.getData();
        }
        try {
            let user = JSON.parse(sessionStorage.getItem('user'));
            this.setState({ user, });
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        const user = this.state.user || {};
        const data = this.props.store.tableSwitch.data;
        const isView = this.props.store.auth.isView;

        // 关闭表格只允许总部人员查看 
        const isClose = !(user.email || "").includes('admin') && !Number(data.es || "0");
        return (
            <div className="menu_flex">
                <Menu {...this.props} />
                {isClose && <div className="menu_flex">
                    <Menu {...this.props} />
                    <div style={{ padding: "0 10px", flex: 1, overflow: 'hidden', textAlign: "center", marginTop: 100, fontSize: 26 }} onClick={() => {
                        this.props.store.menu.onChangeDisplay('')
                    }}>表格关闭中暂时无法查看!</div>
                </div>}
                {!isClose &&
                    <div className="menu-top-content">
                        <UserTop {...this.props} />
                        <div id="table-parent" style={{ padding: "0 10px", flex: 1, overflowY: 'auto' }} onClick={() => {
                            this.props.store.menu.onChangeDisplay('')
                        }}>
                            <Switch>
                                <Route path="/table/compared/detail/:id" component={comparedDetail} />
                                <Route path="/table/compared/daydetail/:id" component={comparedDetail} />
                                <Route path="/table/contract_manage" component={contract} />
                                <Route path="/table/BpSave" component={BpSave} />
                                <Route path="/table/banquetFacilities" component={banquetFacilities} />
                                <Route path="/table/systemStatistical" component={systemStatistical} />
                                <Route path="/table/meetingMinutes" component={meetingMinutes} />
                                <Route path="/table/doobi" component={DooBi} />
                                <Route path="/table/urgent" component={urgent} />

                                <Route path="/table/monthlyreview" component={monthlyReview} />

                                <Route path="/table/compared" component={compared} />
                                <Route path="/table/headquarters" component={Headquarters} />
                                <Route path="/table/labelmanagement" component={LabelManagement} />
                                <Route path="/table/comments" component={comments} />
                                <Route path="/table/personal" component={personal} />
                                <Route path="/table/performanceReview" component={performanceReview} />
                                <Route path="/table/monthlyAnalysis" component={monthlyAnalysis} />
                                <Route path="/table/personnelAssessment" component={financePersonnel} />
                                <Route path="/table/kpifollow" component={kpifollow} />
                                <Route path="/table/salesPersonnelAssessment" component={salesPersonnel} />

                                <Route path="/table/mayday" component={mayDay} />
                                <Route path="/table/nationalday" component={nationalDay} />


                                {/* 坪效 */}
                                <Route path="/table/efficiency" component={efficiency} />
                                <Route path="/table/effictdescription" component={effictdescription} />
                                <Route path="/table/effect1_2" component={effect1_2} />

                                {/* 总部表格 */}
                                <Route path="/table/headquartersmonth" component={HeadquartersMonth} />
                                <Route path="/table/headquartersyear" component={HeadquartersYear} />
                                <Route path="/table/roomsKPIAnalysisSummary" component={roomsKPIAnalysisSummary} />
                                <Route path="/table/guestReviewImport" component={guestReviewImport} />

                                <Route path="/table/dailyMonth" component={dailyMonth} />
                                <Route path="/table/dailyChart" component={dailyChart} />
                                <Route path="/table/dailyMonthAllHotels" component={dailyMonthAllHotels} />
                                <Route path="/table/dailyMonthAllHotels1_4" component={dailyMonthAllHotels1_4} />
                                <Route path="/table/dailyMonthAllHotels1_5" component={dailyMonthAllHotels1_5} />
                                <Route path="/table/BPBudgetSummary8_2_1" component={BPBudgetSummary8_2_1} />
                                <Route path="/table/BPBudgetSummary" component={BPBudgetSummary} />


                                {/* 特许酒店 */}
                                <Route path="/table/charter/one" component={charterFirst} />
                                <Route path="/table/charter/two" component={charterSecond} />
                                <Route path="/table/charter/three" component={charterThird} />
                                <Route path="/table/charter/four" component={charterFourth} />
                                <Route path="/table/charter/summary" component={charterSummary} />

                                <Route path="/table/hotel/:id" component={Hotel} />
                                <Route path="/table/user" component={User} />
                                <Route path="/table/setting" component={Setting} />
                                {/* <Route path="/table/week" component={WeekMeeting} /> */}
                                <Route path="/table/daily" component={daily} />
                                <Route path="/table/cover" component={cover} />
                                <Route path="/table/pdf" component={pdf} />
                                <Route path="/table/meetingflash" component={meetingFlash} />


                                <Route path="/table/criticism/:id/:name" component={criticism} />

                                {/* <Route path="/table/1_1" component={table1_1} />
                                <Route path="/table/1_2" component={table1_2} />
                                <Route path="/table/1_3" component={table1_3} /> */}
                                <Route path="/table/1" component={table1} />

                                {/* 2 */}
                                <Route path="/table/2_1" component={table2_1} />
                                <Route path="/table/2_2" component={table2_2} />
                                <Route path="/table/2_3" component={table2_3} />
                                <Route path="/table/2_7" component={table2_7} />
                                <Route path="/table/2_8" component={table2_8} />
                                {/* <Route path="/table/2_4" component={table2_4} />
                                <Route path="/table/2_5" component={table2_5} />
                                <Route path="/table/2_6" component={table2_6} />
                            
                                <Route path="/table/2_9" component={table2_9} /> */}

                                {/* 3 */}
                                <Route path="/table/3_1" component={table3_1} />
                                <Route path="/table/3_2" component={table3_2} />
                                <Route path="/table/3_3" component={table3_3} />

                                {/* 4 */}
                                <Route path="/table/4_2/holiday/summary" component={table4_2_holidaySummary} />
                                <Route path="/table/4_1" component={table4_1} />
                                <Route path="/table/4_2_1" component={table4_2} />
                                <Route path="/table/4_2/fullRoom" component={fullRoom} />
                                <Route path="/table/4_2_summary" component={table4_2_summary} />
                                <Route path="/table/4_2_2" component={table4_2_2} />
                                <Route path="/table/4_2_3" component={table4_2_3} />
                                <Route path="/table/4_2_4" component={table4_2_4} />
                                <Route path="/table/4_2_5" component={table4_2_5} />
                                <Route path="/table/4_2_6" component={table4_2_6} />
                                <Route path="/table/4_2_7" component={table4_2_7} />

                                {/* 4.0新表 2023 */}
                                <Route path="/table/4_3_1_new" component={news4_3_1} />
                                <Route path="/table/4_3_2_new" component={news4_3_2} />
                                <Route path="/table/4_2_1_new" component={news4_2_1} />
                                <Route path="/table/4_2_2_new" component={news4_2_2} />

                                {/* 区域报表图表 */}
                                <Route path="/table/chineseNewYear" component={chineseNewYear_4_2} />
                                <Route path="/table/areaMayDay" component={mayDay_4_2} />
                                <Route path="/table/eleven" component={eleven_4_2} />
                                <Route path="/table/annualRegional" component={year_4_2} />


                                <Route path="/table/4_3" component={table4_3} />
                                <Route path="/table/4_4" component={table4_4} />
                                <Route path="/table/4_5" component={table4_5} />

                                {/* 5 */}
                                <Route path="/table/5_10" component={table5_10} />
                                <Route path="/table/5_1" component={table5_1} />
                                <Route path="/table/5_0" component={table5} />
                                <Route path="/table/5_2" component={table5_2} />
                                <Route path="/table/5_3" component={table5_3} />
                                <Route path="/table/5_5" component={table5_5} />
                                <Route path="/table/5_6" component={table5_6} />
                                <Route path="/table/5_8" component={table5_8} />
                                <Route path="/table/5_9" component={table5_9} />

                                {/* 6 */}
                                <Route path="/table/6_1" component={table6_1} />
                                <Route path="/table/6_2" component={table6_2} />
                                <Route path="/table/6_3" component={table6_3} />
                                {/* <Route path="/table/6_4" component={table6_4} />
                                <Route path="/table/6_5" component={table6_5} /> */}

                                {/* 7 */}
                                <Route path="/table/7_1" component={table7_1} />
                                <Route path="/table/7_1_1" component={table7_1_1} />
                                <Route path="/table/7_1_2" component={table7_1_2} />
                                <Route path="/table/7_2" component={table7_2} />
                                <Route path="/table/7_3" component={table7_3} />
                                <Route path="/table/7_4" component={table7_4} />
                                <Route path="/table/7_5" component={table7_5} />
                                <Route path="/table/7_6" component={table7_6} />
                                <Route path="/table/7_7" component={table7_7} />
                                <Route path="/table/7_8" component={table7_8} />

                                {/* 8 */}
                                <Route path="/table/8_1" component={table8_1} />

                                {/* 9 */}
                                <Route path="/table/9_1" component={table9_1} />
                                <Route path="/table/9_2" component={table9_2} />
                                <Route path="/table/9_3" component={table9_3} />
                                <Route path="/table/9_4" component={table9_4} />
                                <Route path="/table/9_5" component={table9_5} />
                                <Route path="/table/9_6" component={table9_6} />
                                <Route path="/table/9_7" component={table9_7} />
                                <Route path="/table/9_9" component={table9_9} />
                                <Route path="/table/9_10" component={table9_10} />

                                {/* 10 */}
                                <Route path="/table/10" component={table10} />
                                <Route path="/table/12" component={table12} />

                                <Route path="/table/bi_home" component={BI_Home} />
                                <Route path="/table/general" component={General} />
                                <Route path="/table/bi_headquarters" component={BI_Headquarters} />
                                <Route path="/table/profit" component={Profit} />

                                <Route path="/table/9_8" component={table9_8} />

                                <Route path="/table/guestrating" component={guestRating} />
                                {/* 未付费酒店无权限 */}
                                <IsAuth
                                    isView={isView}
                                    defaultComponent={null}
                                >
                                    <Route path="/table/otafillin" component={ota_fillIn} />
                                    <Route path="/table/otashow" component={ota_show} />
                                    <Route path="/table/otashowctrip" component={OTA1_2} />
                                    <Route path="/table/otashowmeituan" component={OTA1_3} />
                                    <Route path="/table/otaapplet" component={OTA1_5} />
                                    <Route path="/table/otaappletrn" component={OTA1_4} />
                                    <Route path="/table/groupOfChannels" component={groupOfChannels} />
                                    <Route path="/table/performanceAnalysis" component={performanceAnalysis} />
                                    <Route path="/table/performancedescription" component={performanceDescription} />
                                    <Route path="/table/analysisChart" component={analysisChart} />
                                    <Route path="/table/groupanalysisChart" component={groupanalysisChart} />

                                    {/* 官网比价 */}
                                    <Route path="/table/price1_1" component={price1_1} />
                                    <Route path="/table/price1_2" component={price1_2} />
                                    <Route path="/table/price1_3" component={price1_3} />

                                    <Route path="/table/consulting" component={consulting} />
                                </IsAuth>

                                <Redirect from="/table" to="/table/cover" />
                            </Switch>
                        </div>
                    </div>
                }


            </div>
        );
    }
}


export default index;


// WEBPACK FOOTER //
// ./src/components/app/index.js